<template>
  <div class="act-record ">
    <div
      v-swiper:mySwiper="swiperOption"
      class=" swiper">
      <div class="swiper-wrapper">
        <div
          v-for="(vo,idx) in allRecordData"
          :key="idx + 'record'"
          class="act-item swiper-slide">
          <div
            v-for="(item,index) in vo"
            :key="index + 'record'"
            class="img-box"
          >
            <img
              :src="avatar"
              class="avatar">
            <span class="overflow-one">{{ item.inviter }}  邀请{{ item.invite_num }}人获得 {{ item.reward }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "InviteRecord",
  props:{
    allRecordData:{
      type: Array,
      default(){
        return []
      }
    }
  },
  computed: {
    ...mapGetters('user', ['avatar']),
    user_uniq_id() {
      return this.$store.state.user.uniq_id
    }
  },
  // eslint-disable-next-line vue/order-in-components
  data(){
    return{
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOninteraction: false
        },
        direction: "vertical",
        initialSlide: 0, // 默认选中
        slideToClickedSlide: false, // 点击切换
        slidesPerView: 5, // 显示数量
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
      },
    }
  }
}
</script>

<style lang="scss" scoped>
.act-record {
  @include Position(1, 5, 50%, 2039px);
  transform: translateX(-50%);
  width: 1105px;
  height: 330px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 50px 91px 40px 87px;
  overflow: hidden;
  box-sizing: border-box;

  .swiper {
    flex: 1;
    height: 290px;
  }

  .swiper-wrapper {
  }

  .act-item {
    display: flex;
    justify-content: space-between;
    max-height: 380px;


    .img-box {
      text-align: left;
      width: 410px;
      display: flex;
      align-items: center;

    }

    span {
      display: inline-block;
      width: 347px;
      letter-spacing: 3px;
      font-size: 16px;
      font-weight: 400;
      color: #FF8B39;
      line-height: 30px;
    }

    .avatar {
      display: inline-block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 15px;
      vertical-align: middle;
    }
  }


}
</style>
